import { render } from "./AppMenuNav.vue?vue&type=template&id=4ec788b5&scoped=true"
import script from "./AppMenuNav.vue?vue&type=script&lang=js"
export * from "./AppMenuNav.vue?vue&type=script&lang=js"

import "./AppMenuNav.vue?vue&type=style&index=0&id=4ec788b5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec788b5"]])

export default __exports__